<template>
  <div>
    <div class="field">
      <label class="label">{{__("Date")}}:</label>
      <span>{{ data.TheDateStr }}</span>
    </div>
    <div class="field">
      <label class="label">{{__("Employee")}}:</label>
      <span>{{ data.WorkerName }}</span>
    </div>
    <div class="field">
      <label class="label">{{__("Content")}}:</label>
      <span>{{ data.Description }}</span>
    </div>
    <div class="field attachments" v-if="data.Images && data.Images.length > 0">
      <label class="label">{{__("Photos")}}:</label>
      <!-- <span>{{ data.Images }}</span> -->
      <ul>
        <li v-for="(image, index) in data.Images" :key="index">
          <a
            :href="
              API_HOST +
                '/files/getImg?src=' +
                image.PathImg +
                '&sessionToken=' +
                sessionToken
            "
            target="_blank"
            >{{ __("Picture") }} {{ image.Subject }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { API_HOST } from "@/services/APointAPI";
import { mapState } from "vuex";
export default {
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      API_HOST,
    };
  },
  computed: {
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
};
</script>

<style scoped>
.field {
  display: grid;
  grid-template-columns: 30% 70%;
  justify-content: space-between;
  margin-bottom: 10px;
}

.label {
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.45px;
  color: var(--color-primary);
}

.attachments ul {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  list-style: none;
}

.attachments ul li a {
  letter-spacing: 0.45px;
  color: var(--color-success-active);
}

.attachments ul li:not(:last-child) a:after {
  content: ",";
}
</style>
